import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListModule } from 'src/@fury/shared/list/list.module';
import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { NgxMaskModule } from 'ngx-mask';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import { PurchaseClaimRoutingModule } from './purchase-claim-routing.module';
import { PurchaseClaimComponent } from './purchase-claim.component';
import { PurchasedItemListComponent } from './purchased-item-list/purchased-item-list.component';
import { CreatePurchaseItemComponent } from './modal/create-purchase-item/create-purchase-item.component';


@NgModule({
  declarations: [
    PurchaseClaimComponent,
    PurchasedItemListComponent,
    CreatePurchaseItemComponent
  ],
  imports: [
    CommonModule,
    PurchaseClaimRoutingModule,
    FurySharedModule,
    ListModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    MatTableModule,
    FlexLayoutModule,
    MatIconModule,
    NgxPaginationModule,
    MatPaginatorModule,
    MatSelectModule,
    MatOptionModule,
    NgxMaskModule,
    MatDatepickerModule,
    MatAutocompleteModule
  ],
  exports: [PurchaseClaimComponent]
})
export class PurchaseClaimModule { }
